import clsx from "clsx";

import { Field, Label, Description, ErrorMessage } from "V2.0/common/fieldset";
import { RadioField, RadioGroup, Radio } from "V2.0/common/radio";

import { IdentifierMode } from "./models";

export default IdentifierModeRadio;

export { IdentifierModeRadioProps };

interface IdentifierModeRadioProps {
  identifierMode: IdentifierMode;
  setIdentifierMode: React.Dispatch<React.SetStateAction<IdentifierMode>>;
  identifiersAvailable: boolean;
}

function IdentifierModeRadio(props) {
  const { identifierMode, setIdentifierMode, identifiersAvailable } = props;
  return (
    <Field>
      <RadioGroup
        className="!space-y-0 flex w-full gap-4"
        value={identifierMode}
      >
        <RadioField
          className={clsx(
            "flex-1 border rounded-lg p-3 cursor-pointer",
            identifierMode === IdentifierMode.FROM_IDENTIFIER
              ? "border-zinc-900 bg-zinc-950/5 dark:border-white dark:bg-white/5"
              : "border-zinc-200 dark:border-zinc-800",
          )}
        >
          <Radio
            value={IdentifierMode.FROM_IDENTIFIER}
            onClick={() => setIdentifierMode(IdentifierMode.FROM_IDENTIFIER)}
          />
          <Label>Pick Number</Label>
          <Description>Single number for calls</Description>
        </RadioField>
        <RadioField
          className={clsx(
            "flex-1 border rounded-lg p-3 cursor-pointer",
            identifierMode === IdentifierMode.ROTATE_IDENTIFER
              ? "border-zinc-900 bg-zinc-950/5 dark:border-white dark:bg-white/5"
              : "border-zinc-200 dark:border-zinc-800",
          )}
        >
          <Radio
            value={IdentifierMode.ROTATE_IDENTIFER}
            onClick={() => setIdentifierMode(IdentifierMode.ROTATE_IDENTIFER)}
          />
          <Label>Rotate Numbers</Label>
          <Description>Rotate numbers for calls</Description>
        </RadioField>
      </RadioGroup>
      {!identifiersAvailable &&
        identifierMode === IdentifierMode.ROTATE_IDENTIFER && (
          <ErrorMessage>No Numbers Available</ErrorMessage>
        )}
    </Field>
  );
}
